import { Observable } from 'rxjs';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '@tripointe/tripointe-cms/services';
import { Breadcrumb } from '@tripointe/tripointe-cms/types';

@Component({
  selector: 'tp-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
  @Input() items: Breadcrumb[] = [];

  breadcrumbItems$: Observable<Breadcrumb[]>;

  constructor(private router: Router, private breadcrumbsService: BreadcrumbsService) {
    this.breadcrumbItems$ = this.breadcrumbsService.breadcrumbs$;
  }

  navigateTo(link: string): void {
    if (!link) {
      return;
    }
    /* Changed to the below to solve issue in Homes where when you are on any tab other than Home, the link in the breadcrumbs back to the Home tab would update the tab content but not the active tab - MJD 2021-02-14 */
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([link]));
  }
}
